module.exports = {
	config: {
	},

	model: {
		toggleData: {},
		config: {
			// tagScope: 'vat',
			// refreshResourcesOnComponentRefresh: false
		}
	},

	methods: {
		prepare(){
			var self = this;
			self.model.toggles = {};

			var categories = (self.model['tag-picker-data'] || {}).options || {}
			var category, categoryIndex, categoryID;
			var categoryDataIndex, categoryData, categoryDataResources;
			var toggleProperties;
			for(categoryIndex in categories){
				category = categories[categoryIndex] || {};
				categoryID = (category.resources || {}).categoryID;

				if(categoryID){
					toggleProperties = {
						name: category.name || (category.resources || {}).code || 'UNKNOWN_CAT_NAME',
						categoryID,
						options: []
					};

					for(categoryDataIndex in category.children || {}){
						categoryData = category.children[categoryDataIndex] || {}
						categoryDataResources = categoryData.resources || {}
						if(categoryData.name && categoryDataResources.categoryID && categoryDataResources.categoryDataID){
							toggleProperties.options.push({
								value: categoryDataResources.categoryDataID,
								name: categoryData.name
							})
						}
					}

					if(toggleProperties.options.length > 0){
						self.model.toggles[`${(category.resources || {}).sort}_${categoryID}`] = toggleProperties
					}
				}
			}
		},
	},

	hooks: {
		onChildChanged: function($element, options){
			this.model.dataJSON = this.model.dataJSON || {};
			this.model.dataJSON[options.fieldCode] = options.value;

			this.parent(function(parentComponent){
				parentComponent.trigger('onChildChanged', {
					fieldCode: this.model.fieldCode,
					value: this.model.dataJSON
				});
			});
		}
	},
}